<template>
  <v-card class="result_card"> <!--  v-bind="bind_selected" -->
    <v-layout row wrap>
      <v-flex xs12 md6 lg6 >
        <v-card-title primary-title>
          <div>
            <div class="result_title_star subheading primary--text" >
              <ais-highlight  :result="result" attribute-name="name" ></ais-highlight>
            </div>
            <div class='caption result_body'>
              <span style="" ><strong>Airport: </strong> <strong><span class="grey--text darken-2" v-text="result.airport_name" /></strong></span><br/>
              <span v-show="result.localizations" ><strong># of POS: <span class="grey--text darken-2" v-text="result.localizations && result.localizations.length || 0" /></strong><br/></span>
              <span v-if="result.last_observation_date_unix_timestamp"><strong>Last update: </strong><span v-text="format(fromUnixTime(result.last_observation_date_unix_timestamp), 'yyyy-MM-dd')" />
              </span>
            </div>
            <div>
              <p class="snippet" v-html="result._snippetResult !== undefined && result._snippetResult.description !== undefined && result._snippetResult.description.value && result._snippetResult.description.value || ''"/>
            </div>
          </div>
        </v-card-title>
      </v-flex>
      <v-flex xs12 md6 lg6 >
        <v-layout row style="padding-bottom:8px;">
          <v-flex xs12>
            <v-btn small slot="activator" class="primary white--text" v-if="displayShowDocument"
               @click.native="showDocument(result); onClickOpen('click-showmore', result.objectID, result.name)" >
                <v-icon dark class="btn_icone">open_in_new</v-icon>
                Show more
            </v-btn>
            <v-btn small slot="activator" class="primary white--text"
              target="_blank" :href="result.url" @click.native="onClickOpen('click-open', result.objectID, result.name)">
              <v-icon dark class="btn_icone">tab</v-icon>
              Open
            </v-btn>
            <v-btn small slot="activator" @click.native="showChangeRequest(result);onClickOpen('click-edit', result.objectID, result.name)">
              <v-icon dark class="btn_icone">edit</v-icon>
              Edit this shop
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row style="padding-bottom:8px; padding-left:8px; padding-right:8px;"
          v-if="user.access_right[algolia_localization_index_name]['show_tag'] == true">
          <v-flex xs12>
            <v-layout row v-show="region">
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="orange" slot="activator">map</v-icon>
                  <span>Region / Country / City / Airport</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 4px;margin-left: 8px;">
                <span v-text="region"/>
              </v-flex>
            </v-layout>
            <v-layout row v-show="retailerAndBrand" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="blue" slot="activator">shopping_cart</v-icon>
                  <span>Retailer | Retail brand</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-text="retailerAndBrand"/>
              </v-flex>
            </v-layout>
            <v-layout row v-show="supplierAndBrand" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="orange" slot="activator">work</v-icon>
                  <span>Supplier | Brand</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-text="retailerAndBrand"/>
              </v-flex>
            </v-layout>

            <v-layout row v-show="category" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="red" slot="activator">list</v-icon>
                  <span>Category</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-text="category"/>
              </v-flex>
            </v-layout>

            <v-layout row v-if="result.who_union && result.who_union.length > 0" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="blue" slot="activator">people</v-icon>
                  <span>Who</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-text="result.who_union.join(', ')" style="word-break: break-all;"/>
              </v-flex>
            </v-layout>

            <v-layout row v-if="result.what_union && result.what_union.length > 0" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="red" slot="activator">shopping_basket</v-icon>
                  <span>What</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-text="result.what_union.join(', ')" style="word-break: break-all;"/>
              </v-flex>
            </v-layout>

            <v-layout row v-if="result.how_union && result.how_union.length > 0" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="light-green" slot="activator">attach_money</v-icon>
                  <span>How</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-text="result.how_union.join(', ')" style="word-break: break-all;"/>
              </v-flex>
            </v-layout>
            <v-layout row v-if="result.other_union && result.other_union.length > 0" >
              <v-flex xs1 class="flag_icon">
                <v-tooltip top>
                  <v-icon color="light-green" slot="activator">work</v-icon>
                  <span>Other</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 style="margin-top: 5px;margin-left: 8px;">
                <span v-text="result.other_union.join(', ')" style="word-break: break-all;"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import resultPanelConstructor from '../ResultPanelConstructor'
import { mapMutations } from 'vuex'
import USER from '@/graphql/User.gql'
import LOGGER from '@/graphql/Logger.gql'

export default {
  name: 'press-result-panel',
  extends: resultPanelConstructor,
  data () {
    return {
      user: false,
      attachment_path: process.env.VUE_APP_ATTACHMENT_PATH,
      algolia_localization_index_name: process.env.VUE_APP_ALGOLIA_LOCALIZATIONS_INDEX_NAME,
      format,
      fromUnixTime
    }
  },
  computed: {
    region () {
      let res = ''
      if (this.result.region !== undefined && this.result.region.length > 0) {
        res += this.result.region
      }
      if (res !== '' && this.result.country !== undefined && this.result.country.length > 0) { res += ' - ' }
      if (this.result.country !== undefined && this.result.country.length > 0) {
        res += this.result.country
      }
      if (res !== '' && this.result.city !== undefined && this.result.city.length > 0) { res += ' - ' }
      if (this.result.city !== undefined && this.result.city.length > 0) {
        res += this.result.city
      }
      return res
    },
    retailerAndBrand () {
      let res = ''
      if (this.result.retailer !== undefined && this.result.retailer.length > 0) {
        res += this.result.retailer.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.retailerBrand !== undefined && this.result.retailerBrand.length > 0) { res += ' - ' }
      if (this.result.retailerBrand !== undefined && this.result.retailerBrand.length > 0) {
        res += this.result.retailerBrand.map(v => v.n).join(', ')
      }
      return res
    },
    supplierAndBrand () {
      let res = ''
      if (this.result.company !== undefined && this.result.company.length > 0) {
        res += this.result.company.map(v => v.n).join(', ')
      }
      if (res !== '' && this.result.brand !== undefined && this.result.brand.length > 0) { res += ' - ' }
      if (this.result.brand !== undefined && this.result.brand.length > 0) {
        res += this.result.brand.map(v => v.n).join(', ')
      }
      return res
    },
    category () {
      // top category
      let res = ''
      if (this.result.category !== undefined && this.result.category.length > 0) {
        res += this.result.category.map(v => v.n).join(', ')
      }
      return res
    }
  },
  methods: {
    ...mapMutations('locationForm', ['setViewedChangeRequest', 'setViewedChangeRequestDialog']),
    ...mapMutations('documentForm', ['setViewedDocument', 'setViewedDocumentDialog']),
    async showDocument (result) {
      await this.setViewedDocument(result)
      this.setViewedDocumentDialog(true)
    },
    async showChangeRequest (result) {
      await this.setViewedChangeRequest(result)
      this.setViewedChangeRequestDialog(true)
    },
    onClickOpen (action, objectId, title) {
      this.$apollo.mutate({
        mutation: LOGGER,
        variables: {
          level: 'info',
          message: JSON.stringify({
            module: this.$route.name,
            action,
            objectId,
            title
          })
        }
      })
    }
  },
  apollo: {
    user: {
      query: USER
    }
  }
}
</script>
<style>
.result_card .v-card__title--primary {
  padding-bottom: 0px!important;
}

.result_card v-card v-layout v-flex v-card-title div {
  width: 100%;
}
</style>
